import { timeoutPromise } from 'services/utils/promises';

const maxTimeout = 1000 * 60 * 4;
const timeoutIterations = 500;

class Token {
    currentTimeout = 0;

    // eslint-disable-next-line class-methods-use-this
    isExpired(dateStr) {
        const dateParts = dateStr.split('-');
        const expiration = new Date(Date.UTC(dateParts[0],
            dateParts[1] - 1, dateParts[2], 23, 59, 0));
        const now = new Date();
        return expiration < now;
    }

    async getToken() {
        if (window.sspToken) {
            if (window.sspToken.tokenData) {
                if (!this.isExpired(window.sspToken.tokenData.expiration)) {
                    return `Advanced ${window.sspToken.tokenData.token}`;
                }
            } else if (window.sspToken.gotToken) {
                return window.sspToken.gotToken.then((tokenData) => {
                    if (!this.isExpired(tokenData.expiration)) {
                        return `Advanced ${tokenData.token}`;
                    }
                    return '';
                });
            }
        } else if (this.currentTimeout < maxTimeout) {
            this.currentTimeout += timeoutIterations;
            await timeoutPromise(timeoutIterations);
            return this.getToken();
        }
        // no token found (logged out / no result from BED?)
        return '';
    }
}

export default new Token();
